"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));
var chartConfig = _interopRequireWildcard(require("@/components/Charts/chart.config.js"));
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import DoughnutChart from '@/components/Charts/DoughnutChart.vue'
// import BarChart from '@/components/Charts/BarChart.vue'
var now = new Date();
var _default = {
  name: 'DetailService',
  bodyClass: 'detail-service-page',
  components: {
    TableServicesActivesCallsList: _components.TableServicesActivesCallsList,
    TableServicesInactivesCallsList: _components.TableServicesInactivesCallsList,
    LineChart: _LineChart.default
    // DoughnutChart
  },
  data: function data() {
    return {
      idService: null,
      service: {},
      dates: [now, now],
      details: {},
      list: [],
      chartData: {},
      chartRequestsTotal: null,
      chartRequestsCompare: null,
      chartRequestsMonetizablesTotal: null,
      listRequestsTotalErros: null,
      totalRequestsMonetizables: {},
      listRequestsTotalsxlistRequestM: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        scales: {
          y: {
            display: true,
            title: {
              display: true
            }
          },
          x: {
            display: true
          }
        },
        plugins: {
          legend: {
            display: false
          },
          elements: {
            point: {
              radius: 0
            }
          }
        },
        elements: {
          point: {
            radius: 0
          }
        }
      },
      optionsDays: [{
        value: 1,
        name: '24 horas'
      }, {
        value: 7,
        name: '7 dias'
      }]
    };
  },
  computed: {
    filterItems: function filterItems() {
      return {
        StartDate: (0, _moment.default)(this.dates[0]).format('YYYY-MM-DD'),
        EndDate: (0, _moment.default)(this.dates[1]).add(1, 'days').format('YYYY-MM-DD'),
        Asset: this.idService
      };
    },
    titleMonitoramento: function titleMonitoramento() {
      var dateInit = (0, _moment.default)(this.dates[0]);
      var dateEnd = (0, _moment.default)(this.dates[1]);
      var diff = dateInit.diff(dateEnd, 'days');
      if (diff === 0) return 'Monitoramento do serviço por hora';
      return 'Monitoramento do serviço por data';
    },
    diffMonetization: function diffMonetization() {
      var total = this.details.TotalFetchs || 0;
      var sucesso = this.details.TotalFetchSuccess || 0;
      return Number(total) - Number(sucesso);
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.idService = id;
    this.updateDataItems();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailServiceActiveDashboard', 'fetchLatestServiceActiveCallDashboard', 'fetchLatestCallServiceActiveChartDashboard', 'featchLastServiceActiveCallsTotal', 'featchLastServiceActiveCallsTotalMonetizables', 'featchLastServiceActiveCallsTotalErros', 'fetchDetailService'])), {}, {
    getDetailService: function () {
      var _getDetailService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.fetchDetailService(this.idService);
            case 2:
              data = _context.sent;
              if (data) {
                this.service = data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDetailService(_x) {
        return _getDetailService.apply(this, arguments);
      }
      return getDetailService;
    }(),
    updateDataItems: function () {
      var _updateDataItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.getDetailService();
              _context2.next = 3;
              return this.getDetails();
            case 3:
              this.getDetailsList();
              _context2.next = 6;
              return this.fillChartData();
            case 6:
              this.getRequestsErrors();
              this.getRequestsTotalsMonetizables();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateDataItems() {
        return _updateDataItems.apply(this, arguments);
      }
      return updateDataItems;
    }(),
    getDetails: function () {
      var _getDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.fetchDetailServiceActiveDashboard(this.filterItems);
            case 2:
              data = _context3.sent;
              if (data) {
                this.details = data;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    getDetailsList: function () {
      var _getDetailsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.fetchLatestServiceActiveCallDashboard(this.filterItems);
            case 2:
              data = _context4.sent;
              if (data) {
                this.list = data.list;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getDetailsList() {
        return _getDetailsList.apply(this, arguments);
      }
      return getDetailsList;
    }(),
    fillChartData: function () {
      var _fillChartData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, labels, services, datasets, _loop, i;
        return _regeneratorRuntime().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.fetchLatestCallServiceActiveChartDashboard(this.filterItems);
            case 2:
              data = _context7.sent;
              if (!data) {
                _context7.next = 17;
                break;
              }
              labels = [];
              services = [];
              datasets = [];
              if (!(data.list && data.list.length)) {
                _context7.next = 16;
                break;
              }
              data.list.map(function (i) {
                if (!labels.includes(i.ResponseDate)) {
                  var dateLabel = (0, _moment.default)(String(i.ResponseDate)).format('HH:mm');
                  labels.push(dateLabel);
                }
                if (!services.includes(i.DigitalAsset)) {
                  services.push(i.DigitalAsset);
                }
              });
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var service, values, _loop2, j, item;
                return _regeneratorRuntime().wrap(function _loop$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      service = services[i];
                      values = [];
                      _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                        var dt, item;
                        return _regeneratorRuntime().wrap(function _loop2$(_context5) {
                          while (1) switch (_context5.prev = _context5.next) {
                            case 0:
                              dt = labels[j];
                              item = data.list.find(function (j) {
                                var dateCompare = (0, _moment.default)(String(j.ResponseDate)).format('HH:mm');
                                return j.DigitalAsset === service && dateCompare === dt;
                              });
                              if (item) {
                                values.push(item.TotalRequests);
                              } else {
                                values.push(0);
                              }
                            case 3:
                            case "end":
                              return _context5.stop();
                          }
                        }, _loop2);
                      });
                      j = 0;
                    case 4:
                      if (!(j < labels.length)) {
                        _context6.next = 9;
                        break;
                      }
                      return _context6.delegateYield(_loop2(), "t0", 6);
                    case 6:
                      j++;
                      _context6.next = 4;
                      break;
                    case 9:
                      item = chartConfig.datasetObjectItem(values, service);
                      datasets.push(item);
                    case 11:
                    case "end":
                      return _context6.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 11:
              if (!(i < services.length)) {
                _context7.next = 16;
                break;
              }
              return _context7.delegateYield(_loop(), "t0", 13);
            case 13:
              i++;
              _context7.next = 11;
              break;
            case 16:
              this.chartData = {
                labels: labels,
                datasets: datasets
              };
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee5, this);
      }));
      function fillChartData() {
        return _fillChartData.apply(this, arguments);
      }
      return fillChartData;
    }(),
    getRequestsErrors: function () {
      var _getRequestsErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, labels, services, datasets, _loop3, i;
        return _regeneratorRuntime().wrap(function _callee6$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.featchLastServiceActiveCallsTotalErros(this.filterItems);
            case 2:
              data = _context10.sent;
              if (!data) {
                _context10.next = 18;
                break;
              }
              labels = [];
              services = [];
              datasets = [];
              if (!(data.list && data.list.length)) {
                _context10.next = 16;
                break;
              }
              data.list.map(function (i) {
                if (!labels.includes(i.ResponseDate)) {
                  var dateLabel = (0, _moment.default)(String(i.ResponseDate)).format('HH:mm');
                  labels.push(dateLabel);
                }
                if (!services.includes(i.DigitalAsset)) {
                  services.push(i.DigitalAsset);
                }
              });
              _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
                var service, values, _loop4, j, item;
                return _regeneratorRuntime().wrap(function _loop3$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      service = services[i];
                      values = [];
                      _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop4() {
                        var dt, item;
                        return _regeneratorRuntime().wrap(function _loop4$(_context8) {
                          while (1) switch (_context8.prev = _context8.next) {
                            case 0:
                              dt = labels[j];
                              item = data.list.find(function (j) {
                                var dateCompare = (0, _moment.default)(String(j.ResponseDate)).format('HH:mm');
                                return j.DigitalAsset === service && dateCompare === dt;
                              });
                              if (item) {
                                values.push(item.TotalRequests);
                              } else {
                                values.push(0);
                              }
                            case 3:
                            case "end":
                              return _context8.stop();
                          }
                        }, _loop4);
                      });
                      j = 0;
                    case 4:
                      if (!(j < labels.length)) {
                        _context9.next = 9;
                        break;
                      }
                      return _context9.delegateYield(_loop4(), "t0", 6);
                    case 6:
                      j++;
                      _context9.next = 4;
                      break;
                    case 9:
                      item = chartConfig.datasetObjectItem(values, service, 'rgb(255 0 0)');
                      datasets.push(item);
                    case 11:
                    case "end":
                      return _context9.stop();
                  }
                }, _loop3);
              });
              i = 0;
            case 11:
              if (!(i < services.length)) {
                _context10.next = 16;
                break;
              }
              return _context10.delegateYield(_loop3(), "t0", 13);
            case 13:
              i++;
              _context10.next = 11;
              break;
            case 16:
              this.listRequestsTotalErros = {
                labels: labels,
                datasets: datasets
              };
              this.generateCompare();
            case 18:
            case "end":
              return _context10.stop();
          }
        }, _callee6, this);
      }));
      function getRequestsErrors() {
        return _getRequestsErrors.apply(this, arguments);
      }
      return getRequestsErrors;
    }(),
    getRequestsTotalsMonetizables: function () {
      var _getRequestsTotalsMonetizables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var data;
        return _regeneratorRuntime().wrap(function _callee7$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.featchLastServiceActiveCallsTotalMonetizables(this.filterItems);
            case 2:
              data = _context11.sent;
              if (data) {
                this.totalRequestsMonetizables = data;
              }
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee7, this);
      }));
      function getRequestsTotalsMonetizables() {
        return _getRequestsTotalsMonetizables.apply(this, arguments);
      }
      return getRequestsTotalsMonetizables;
    }(),
    generateCompare: function () {
      var _generateCompare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              this.chartRequestsCompare = {
                labels: this.chartData.labels,
                datasets: [_objectSpread({}, this.chartData.datasets[0]), _objectSpread(_objectSpread({}, this.listRequestsTotalErros.datasets[0]), {}, {
                  label: 'Erros',
                  backgroundColor: chartConfig.CHART_COLORS.red,
                  borderColor: chartConfig.CHART_COLORS.red
                })]
              };
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee8, this);
      }));
      function generateCompare() {
        return _generateCompare.apply(this, arguments);
      }
      return generateCompare;
    }(),
    goBack: function goBack() {
      this.$router.back();
    }
  })
};
exports.default = _default;